// extracted by mini-css-extract-plugin
export default {"container":"mZ6ek4","trigger":"HGbjQM","menu":"qDXKKk","menuItem":"jlTh04","itemLabel":"uyI67Y","itemIcon":"WH6iLa","check":"LfGVz3"};